<template>
    <div class="modal fade" id="change-weekdays-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" style="min-height: 300px;">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>Ändra dagar</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>
                <form enctype="multipart/form-data" id="changeWeekdaysForm" @submit="updateWeekdays">
                <div class="modal-body pb-5">

                        <div class="d-flex justify-content-between">
                            <div class="" v-for="(day, index) in days">
                                <div class="form-group text-center">
                                    <label>{{day}}</label>
                                    <input v-if="batch" type="checkbox" class="form-control ml-3" name="day[]"
                                           id="day[]" v-model="activeDays[index+1]">
                                </div>
                            </div>
                        </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label for="message">{{ transEdit('Valfritt meddelande till avbokade kunder')}}</label>
                      <textarea name="message" class="form-control" v-model="message"></textarea>
                    </div>
                  </div>
                        <div class="row pb-20">
                            <div class="col-md-6">
                                <div>
                                    <span v-if="loading"><i class="fa fa-spin fa-fw fa-refresh"></i>
                                        {{transEdit('loading')}}...</span>
                                </div>
                                <div class="text-danger">
                                    <span v-if="error">{{transEdit('admin.schedules.create.conflicts-exist')}}</span>
                                </div>
                                <input class="hidden" id="change-weekdays-modal-batch-hidden" v-model-inject="batch_id">
                                <input class="hidden" id="change-weekdays-modal-date">
                            </div>
                        </div>

                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary"
                            ><i class="fa fa-pencil"></i> Ändra dagar
                    </button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    import VueMultiselect from "vue-multiselect/src/Multiselect";

    export default {
        name: "admin-schedules-batch-modal-change-weekdays",
        components: {VueMultiselect},

        data() {
            return {
                loading: true,
                error: false,
                batch_id: null,
                batch: null,
                start: null,
                end: null,
                days: [
                    'Måndag',
                    'Tisdag',
                    'Onsdag',
                    'Torsdag',
                    'Fredag',
                    'Lördag',
                    'Söndag'
                ],
                activeDays: [false, false, false, false, false, false, false, false],
              message: '',
            }
        },
        methods: {
            updateWeekdays(e = null) {
                e.preventDefault();

                this.error = false;
                this.loading = true;
                let thisModal = $("#change-weekdays-modal");
                let formData = new FormData();
                let checkbox = $("#changeWeekdaysForm").find("input[type=checkbox]");
                $.each(checkbox, function(key, val) {
                    formData.append($(val).attr('name'), $(val).is(':checked'))
                });
                formData.append('batch_id', $("#change-weekdays-modal-batch-hidden").val());
                formData.append('current_date', $("#change-weekdays-modal-date").val());
              formData.append('message', this.message);

                axios({
                    method: 'post',
                    url: 'adminschedule/batch/changeweekdays',
                    data: formData,
                    contentType: false,
                    processData: false,
                }).then((response) => {
                    this.loading = false;
                    this.$emit('refresh');
                    thisModal.modal('toggle');
                });
            },
            getBatch() {
                axios.get('adminschedule/batch/' + this.batch_id).then((res) => {
                    this.batch = res.data;
                    this.end = this.getDate(this.batch.period_end);
                    if (this.batch.weekdays === 'alla') {
                        this.activeDays.forEach(day => day = true);
                    } else {
                        let days = this.batch.weekdays.split(',');
                        days.forEach(day => this.activeDays[day] = true);
                    }
                    this.loading = false;
                });
            },
            getTreatmentIds() {
                if (!this.selectedTreatment || !this.selectedTreatment.length) return [];
                let ids = [];
                for (let treatment of this.selectedTreatment) {
                    ids.push(treatment.id);
                }

                return ids;
            },
            getDate(dateString) {
                return moment(dateString).format('YYYY-MM-DD')
            },
        },
        watch: {
            'batch_id': function (val, oldVal) {
                this.getBatch();
                this.loading = false;
            }
        },
        mounted() {
            this.loading = true;
        }
    }
</script>

<style scoped>

</style>
